import { FunctionComponent, useCallback, useEffect } from 'react';
import { matchPath, useHistory, useLocation } from 'react-router-dom';

import { useGlobalState, useGlobalDispatch } from './contexts';
import { AdminRouteName } from './admin_screens/CONSTANTS';

import Dots from './components/Loading/Dots';
import DashboardWrap from './components/DashboardWrap';
// import GifLoader from './components/Loading/GifLoader';

export interface IAuthComp {
  children?: any;
}

const globalDispatch = useGlobalDispatch;
const globalState = useGlobalState;

const AuthComp: FunctionComponent<IAuthComp> = ({ children }) => {
  const { get_profile } = globalDispatch();
  const { profileLoading } = globalState();
  const { push } = useHistory();
  const { pathname } = useLocation();

  const shouldGetProfile = ![
    '/',
    '/forgot-password',
    '/password-reset',
  ].includes(pathname);

  const IsPathNotEqual = useCallback((pathname) => {
    const routePaths = Object.values(AdminRouteName);
    const match = matchPath(pathname, {
      path: routePaths,
      exact: true,
      strict: false,
    });
    if (!routePaths.includes(match.path) || match.path === '*') {
      return push(`/${AdminRouteName.notFoundRoute}`);
    }
  }, [pathname]);

  useEffect(() => {
    IsPathNotEqual(pathname);
  }, [IsPathNotEqual]);

  useEffect(() => {
    if (localStorage.token && shouldGetProfile) {
      get_profile();
    }
  }, [localStorage.token, shouldGetProfile]);

  useEffect(() => {
    if (!localStorage.token && !profileLoading && shouldGetProfile) {
      push('/');
    }
  }, [localStorage.token, profileLoading, pathname, shouldGetProfile]);

  if ((profileLoading && shouldGetProfile)) {
    return (
      <DashboardWrap disabled>
        <div className="general-loader">
          <Dots />
        </div>
      </DashboardWrap>
    );
  }

  return <div>{children}</div>;
};

export default AuthComp;
